import React from 'react'
import ReactDOM from 'react-dom/client'
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './auth/msalConfig'
import App from './App'
import './styles/globals.css'

/**
 * Capture the invitation token from the URL BEFORE MSAL initialises.
 * MSAL's redirect flow will destroy the query string, so we stash the
 * token in sessionStorage where the NotLinked component can find it
 * after auth completes.
 *
 * We also clean the URL so a page refresh doesn't re-process the token.
 */
const INVITATION_TOKEN_KEY = 'equivolt_pending_invitation_token'
const urlParams = new URLSearchParams(window.location.search)
const urlToken = urlParams.get('token')
if (urlToken && urlToken.startsWith('EQV-') && urlToken.length <= 100) {
  sessionStorage.setItem(INVITATION_TOKEN_KEY, urlToken)
  const cleanUrl = new URL(window.location.href)
  cleanUrl.searchParams.delete('token')
  window.history.replaceState({}, '', cleanUrl.toString())
}

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload
    ) {
      const payload = event.payload as AuthenticationResult
      if (payload.account) {
        msalInstance.setActiveAccount(payload.account)
      }
    }
  })

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  )
})
